export const COLUMN_ORDER = ["index_set_title", "stream_titles", "types"];
export const DEFAULT_LAYOUT = {
  entityTableId: "field-type",
  defaultPageSize: 20,
  defaultSort: { attributeId: "index_set_title", direction: "asc" },
  defaultDisplayedAttributes: ["index_set_title", "stream_titles", "types"],
  defaultColumnOrder: ["index_set_title", "stream_titles", "types"]
};
